var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "step_component_wrapper"
    }
  }, [_c('div', {
    staticClass: "slot-content"
  }, [_c('v-select', {
    ref: "select",
    attrs: {
      "label": "ragioneSociale",
      "options": _vm.clienti,
      "placeholder": _vm.$Jed.firstUpperTranslate('select a %1$s from the list below', null, {
        key: 'customer'
      }, 'male'),
      "selectStyle": {
        'background-color': 'white',
        'border-radius': '4px'
      },
      "tagStyle": {
        'background-color': '#5897fb',
        color: 'white',
        padding: '3px'
      },
      "menuStyle": {
        position: 'relative',
        'max-height': '150px'
      },
      "activeStyle": {
        'background-color': '#5897fb',
        color: 'white'
      },
      "highStyle": {
        'background-color': '#ccc',
        color: 'white'
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "slot-button"
  }, [(!_vm.backTo1Allowed) ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.$root.logout()
      }
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('logout', null)))]) : _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.$emit('backward')
      }
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('back', null)))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary-default",
    attrs: {
      "disabled": _vm.selected == null
    },
    on: {
      "click": _vm.forward
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('confirm', null)))])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e9610092","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loader/steps/SelezionaCliente.vue
// module id = 1473
// module chunks = 1